import { MapPlusButton } from 'features/siteView'
import React, { FC, useState } from 'react'
import styled from 'styled-components'

import { HudPlusMenu } from './HudPlusMenu'

const AddSectionContainer = styled.div<{ $menuOpen: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: end;
  width: ${({ $menuOpen }) => ($menuOpen ? '240px' : '56px')};
  transition: width 200ms;
  overflow: hidden;
`

export const HudPlusMenuOverlayContainer: FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <AddSectionContainer $menuOpen={isMenuOpen}>
      <HudPlusMenu isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
      <MapPlusButton isSelected={isMenuOpen} setIsSelected={setIsMenuOpen} />
    </AddSectionContainer>
  )
}
